"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionGroup = AccordionGroup;
exports["default"] = void 0;
var _fuseDesign = require("@tvg/fuse-design");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledAccordionGroup = require("./styled-accordion-group");
var _excluded = ["className", "title", "titleTag", "description", "hideBorder", "children", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var defaultProps = {
  className: 'fuse-accordion-group',
  dataTestId: 'fuse-accordion-group-test-id',
  description: undefined,
  title: undefined,
  titleTag: 'h2',
  hideBorder: false
};
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  description: _propTypes["default"].string,
  title: _propTypes["default"].string,
  titleTag: _propTypes["default"].string,
  hideBorder: _propTypes["default"].bool
};
function AccordionGroup(_ref) {
  var className = _ref.className,
    title = _ref.title,
    titleTag = _ref.titleTag,
    description = _ref.description,
    hideBorder = _ref.hideBorder,
    children = _ref.children,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  var hasText = title || description;
  return /*#__PURE__*/_react["default"].createElement(_styledAccordionGroup.StyledAccordionGroup, _extends({
    className: className,
    "data-testid": dataTestId
  }, props), hasText && /*#__PURE__*/_react["default"].createElement(_fuseDesign.SpacingWrapper, {
    marginBottom: "m"
  }, /*#__PURE__*/_react["default"].createElement(_styledAccordionGroup.StyledTextWrapper, {
    xxs: "12"
  }, title && /*#__PURE__*/_react["default"].createElement(_styledAccordionGroup.StyledTitle, {
    size: {
      xxs: '3',
      m: '4',
      l: '5'
    },
    tag: titleTag,
    type: "heading"
  }, title), description && /*#__PURE__*/_react["default"].createElement(_styledAccordionGroup.StyledDescription, {
    size: "1",
    type: "paragraph"
  }, description))), children.map(function (accordion, i) {
    return /*#__PURE__*/_react["default"].createElement(_styledAccordionGroup.StyledSingleAccordion
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: i,
      className: "fuse-accordion-group__accordion",
      "data-testid": "fuse-accordion-group-accordion-".concat(i),
      hideBorder: hideBorder
    }, accordion);
  }));
}
AccordionGroup.propTypes = propTypes;
AccordionGroup.defaultProps = defaultProps;
AccordionGroup.displayName = 'AccordionGroup';
var _default = exports["default"] = AccordionGroup;